import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { PublicLayoutNavBar } from "../components/PublicLayoutNavBar";

export const PublicLayout = () => {
  return (
    <Box
      sx={{
      }}
    >
      <PublicLayoutNavBar />

      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",      // vertical center
          justifyContent: "center",  // horizontal center
          overflow: "hidden",        // optional
          flexDirection: "column",
        }}
      >
        <Outlet />
      </Box>
    </Box>

  );
};
